import { render, staticRenderFns } from "./StorageChangeIndex.vue?vue&type=template&id=0b7c08bd&"
import script from "./StorageChangeIndex.vue?vue&type=script&lang=js&"
export * from "./StorageChangeIndex.vue?vue&type=script&lang=js&"
import style0 from "./StorageChangeIndex.vue?vue&type=style&index=0&lang=css&"
import style1 from "./StorageChangeIndex.vue?vue&type=style&index=1&lang=less&"
import style2 from "./StorageChangeIndex.vue?vue&type=style&index=2&media=print&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports